import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "share-your-work-with-others"
    }}>{`Share your work with others`}</h1>
    <p>{`Unless you've written a script/plugin solely for yourself, you're probably going to want to share it with others. This section explains how to take your plugin into the wider world, and let other users know about it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      